<script setup lang="ts">
// biome-ignore lint/complexity/noBannedTypes: Init Biome
type Separator = {}
defineProps<Separator>();
</script>
<template>
    <div class="ds-separator"></div>
</template>
<style scoped lang="scss">
.ds-separator {
    width: 100%;
    min-height: 1px;
    background-color: $stroke-soft-200;
}
</style>
